export default function About() {
  return (
    <>
      <div className={"content-wrapper"}>
        <div className={"content land"}>
          <h1>Contrax Technologies, Inc.</h1>
          <p className={"start-head"}>
            Since being founded in 1987, we have grown from 1,500 square feet to
            12,000 square feet and are looking to expand further in the near
            future. We are a privately owned, independent electronics based,
            full service technology company specializing in printed circuit
            board surface mount/through-hole technology, cable and chassis
            assembly, computer integration, and in-circuit and functional
            testing services for both the commercial and government markets.
            Contrax is a sales driven organization that emphasizes assurance and
            customer satisfaction. Nothing is too small or too big for us! We do
            small to large production runs with a quick turnaround. Our talented
            management and technical staff have progressively evolved, which
            assures continuing strength and growth within the company. We
            possess diverse capabilities. Our scientific and technical skills
            combined with a progressive quality assurance program have kept us
            ahead in this rapidly changing and highly competitive industry. We
            also offer design/engineering services for those companies who
            require it. We at Contrax are constantly on the move. These are a
            few of the several distinguishing factors that stand as key
            contributors to our success, making us a reliable supplier.
          </p>
        </div>
      </div>
      <div className={"bg-img"}>
        <img src="./Scripts/Assets/contrax_logo.svg" alt="" class="logo" />
      </div>
    </>
  );
}
